import React from "react";
import { Typography, Paper, Box, Link } from "@mui/material";

function Credits() {
  return (
    <Box
      sx={{
        backgroundColor: "#f4f9ff",
        minHeight: "100vh",
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      {/* Header */}
      <div className="header">
        <img src="/logo.png" alt="Smart Parking Logo" className="logo" />
        <div className="heading-text">
          <br />
          <Typography variant="h4" className="title">
            Smart Parking App
          </Typography>
          <Typography variant="body2" className="caption">
            "Empowering Digital India .."
          </Typography>
        </div>
      </div>

      {/* Main Content */}
      <Paper
        elevation={3}
        sx={{
          p: 3,
          borderRadius: 4,
          backgroundColor: "#ffffff",
          maxWidth: 380,
          width: "87%",
          mx: "auto",
        }}
      >
        <Typography
          variant="h5"
          sx={{ mb: 2, fontWeight: "medium", color: "#1565c0" }}
        >
          Developer Credits
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
           We express our sincere gratitude to <strong>Spandan Manna</strong> for his sole development of the Smart Parking App. His expertise, dedication, and innovative approach have been instrumental in creating a seamless and efficient parking solution for the Kalimpong Municipality.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          About the Developer
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          Spandan Manna is a skilled developer whose technical proficiency and commitment to excellence have significantly shaped the functionality and user experience of this application. His work reflects a deep understanding of modern development practices and a passion for advancing digital solutions.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          Contact the developer
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          For inquiries or feedback regarding the Smart Parking App, please reach out to our developer:
          <br />
          Email: <Link href="mailto:spandan@apptech.co.in" sx={{ color: "#1565c0" }}>spandan@apptech.co.in</Link>
          <br />
          Phone: <Link href="tel:+919091062010" sx={{ color: "#1565c0" }}>+91 90910 62010</Link>
        </Typography>
      </Paper>
    </Box>
  );
}

export default Credits;